
import SvgIcon from "@/components/common/SvgIcon.vue";
import {computed, ref} from "vue";
import store from "@/store";

export default {
  name: "Navbar",
  components: {SvgIcon},
  setup() {
    const isLogin = computed(() => store.state.isLogin);
    const menuOpen = ref(false);
    const closeMenu = () => {
      menuOpen.value = false;
    }
    const onMenuCLicked = () => {
      menuOpen.value = !menuOpen.value;
    }
    const onLogout = () => {
      store.commit('onLogout');
      closeMenu();

    }

    const onLogoClicked = () => {
      window.open("https://timessquare.com.hk", "_blank");
      // router.push({
      //   name: 'Home',
      // });
    }

    const onLangClicked = () => {
      document.getElementById("footer")?.scrollIntoView({
        behavior: "smooth"
      });
    }

    const onTypeChange = (type: number) => {
      store.commit('onTypeChange', type);
      closeMenu();
    }

    return {
      isLogin,
      menuOpen,
      onLogoClicked,
      onMenuCLicked,
      onLogout,
      onTypeChange,
      onLangClicked,
    }
  }
}
